import {GETLANGUAGE,
    GETALLLANGUAGE,
    GETONELANGUAGE,
    PAGINATIONWORD,
    GETFORINGLANGUAGE,
    GETINTERFACELANGUAGE,
    GETSENTENCESTAT,
    GETLEARNINGSTATS,
    GETONELEARNINGLANGUAGE,
    GETWORD,
    GETDETAILWORD,
    GETSENTENCE,
    GETSENTENCEFILTER,
    GETDETAILSENTENCE,
    GETNOTIFICATION,
    PAGINATIONSENTENCE,
    GETONEINTERFACELANGUAGE,
    GETVOCABULARYSTAT,
    GETWORDFILTER,
    GETGRAMMARSTAT,
    GETRULE,
    GETDETAILRULE,
    GETRULEFILTER,
    SAVEWORD,
    GETINTERFACETRANSLATION,
    GETINTERFACEFILTER,
    GETLIVESITUATION,
    GETSITUATIONFILTER,
    GETONELIVESITUATION,
    ADDLIVESITUATION,
    GETSITUATIONSELECT,
    GETSITUATIONSSTAT,
    PAGINATI_LIV_SITUATIN,
    GETNOTIFICATIONSELECT,
    ADDLANG} from '../actions/constant';

const INITIAL_STATE = {count: {}, error_lang: {},
    all_lang: {}, lang_one: {}, foring_lang: {}, situation_select: [], notification_select: [], interface_lang: {}, situations: {},situation_one: {}, error_situation: {}, error_word: {}, learning_stats: {}, learning_lang_one: {}, words: {},
    words_detail: {}, learning_lang: {}, sentense:{}, sentence_stat: [], sentense_detail:{}, notofication_detail:{}, interface_one: {}, grammar: {}, interface_translation: {}, rule_detail: {}, vocabulary_stat: [], grammar_stat: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case ADDLANG:
            return {...state, error_lang:action.payload.error_addLang};
        case GETLANGUAGE:
            return {...state, count:action.payload.data};
        case GETALLLANGUAGE:
            return {...state, all_lang:action.payload.data};
        case GETONELANGUAGE:
            return {...state, lang_one:action.payload.data};
        case GETFORINGLANGUAGE:
            return {...state, foring_lang:action.payload.data};
        case GETINTERFACELANGUAGE:
            return {...state, interface_lang:action.payload.data};
        case GETLEARNINGSTATS:
            return {...state, learning_stats:action.payload.data};
        case GETONELEARNINGLANGUAGE:
            return {...state, learning_lang_one:action.payload.data};
        case GETWORD:
            return {...state, words:action.payload.data};
        case PAGINATIONWORD:
            return {...state, words:action.payload.data};
        case GETWORDFILTER:
            return {...state, words:action.payload.data};
        case GETDETAILWORD:
            return {...state, words_detail:action.payload.data};
        case GETSENTENCE:
            return {...state, sentense:action.payload.data};
        case GETSENTENCEFILTER:
            return {...state, sentense:action.payload.data};
        case PAGINATIONSENTENCE:
            return {...state, sentense:action.payload.data};
        case GETDETAILSENTENCE:
            return {...state, sentense_detail:action.payload.data};
        case GETNOTIFICATION:
            return {...state, notofication_detail:action.payload.data};
        case GETSENTENCESTAT:
            return {...state, sentence_stat:action.payload.data};
        case GETVOCABULARYSTAT:
            return {...state, vocabulary_stat:action.payload.data};
        case GETGRAMMARSTAT:
            return {...state, grammar_stat:action.payload.data};
        case GETSITUATIONSSTAT:
            return {...state, situation_stat:action.payload.data};
        case GETRULE:
            return {...state, grammar:action.payload.data};
        case GETRULEFILTER:
            return {...state, grammar:action.payload.data};
        case GETDETAILRULE:
            return {...state, rule_detail:action.payload.data};
        case GETONEINTERFACELANGUAGE:
            return {...state, interface_one:action.payload.data};
        case GETINTERFACETRANSLATION:
            return {...state, interface_translation:action.payload.data};
        case GETINTERFACEFILTER:
            return {...state, interface_translation:action.payload.data};
        case SAVEWORD:
            return {...state, error_word:action.payload.error_word};
        case GETLIVESITUATION:
            return {...state, situations:action.payload.data};
        case PAGINATI_LIV_SITUATIN:
            return {...state, situations:action.payload.data};
        case GETSITUATIONFILTER:
            return {...state, situations:action.payload.data};
        case ADDLIVESITUATION:
            return {...state, error_situation: action.payload.error_situation};
        case GETONELIVESITUATION:
            return {...state, situation_one:action.payload.data};
        case GETSITUATIONSELECT:
            return {...state, situation_select:action.payload.data};
        case GETNOTIFICATIONSELECT:
            return {...state, notification_select:action.payload.data};
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_language.js